"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnFeedActivityUpdate = void 0;
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const lodash_es_1 = require("lodash-es");
const useFetchFeedActivities_1 = require("../api/useFetchFeedActivities");
const useActivityFeedFiltersState_1 = require("./useActivityFeedFiltersState");
const useOnFeedActivityUpdate = (entities) => {
    const queryClient = (0, frontend_infra_reactquery_1.useQueryClient)();
    const { selectedFilters } = (0, useActivityFeedFiltersState_1.useActivityFeedFiltersState)();
    const onFeedActivityUpdate = (newActivity) => {
        const querykey = [useFetchFeedActivities_1.GET_FEEDS_API_UNIQUE_KEY, entities.map((entity) => entity.id), selectedFilters];
        const feedListQueryData = queryClient.getQueryData(querykey);
        const feedListDataCloned = (0, lodash_es_1.cloneDeep)(feedListQueryData);
        if ((feedListDataCloned?.pages || []).length > 0) {
            const feedDataFirstPage = feedListDataCloned?.pages?.[0];
            const activityType = newActivity.activity.type;
            if (feedDataFirstPage?.activityCountByType) {
                const activityCount = feedDataFirstPage.activityCountByType.find(({ type }) => type === activityType);
                if (activityCount) {
                    activityCount.count += 1;
                }
                else {
                    feedDataFirstPage?.activityCountByType.push({
                        count: 1,
                        type: activityType,
                    });
                }
            }
            feedDataFirstPage?.results?.unshift(newActivity);
            queryClient.setQueryData(querykey, feedListDataCloned);
        }
    };
    return onFeedActivityUpdate;
};
exports.useOnFeedActivityUpdate = useOnFeedActivityUpdate;
//# sourceMappingURL=useOnFeedActivityUpdate.js.map